import { audioPrefs } from "./audioPrefs.js";

/** Tiny WebAudio blips — no asset files needed. Mute state lives in `audioPrefs`. */
export class Sfx {
  private ctx?: AudioContext;

  isMuted(): boolean {
    return audioPrefs.isMuted();
  }

  toggleMute(): boolean {
    return audioPrefs.toggleMuted();
  }

  private play(freq: number, duration: number, type: OscillatorType = "sine", gain = 0.04): void {
    if (audioPrefs.isMuted()) return;
    try {
      this.ctx ??= new AudioContext();
      const ctx = this.ctx;
      const osc = ctx.createOscillator();
      const amp = ctx.createGain();
      osc.type = type;
      osc.frequency.value = freq;
      amp.gain.value = gain;
      osc.connect(amp).connect(ctx.destination);
      const now = ctx.currentTime;
      osc.start(now);
      amp.gain.exponentialRampToValueAtTime(0.0001, now + duration);
      osc.stop(now + duration);
    } catch {
      // Audio is best-effort.
    }
  }

  chat(): void {
    this.play(660, 0.08, "triangle");
  }

  coffee(): void {
    this.play(440, 0.12, "sine");
  }

  burnout(): void {
    this.play(180, 0.25, "sawtooth", 0.05);
  }

  fanfare(): void {
    const notes = [523, 659, 784, 1047];
    notes.forEach((f, i) => {
      setTimeout(() => this.play(f, 0.18, "triangle", 0.05), i * 120);
    });
  }

  type(): void {
    this.play(300 + Math.random() * 120, 0.03, "square", 0.015);
  }
}
